
//Definición de defaults

export const defaultPais: PaisProps = {
    idPais:         0,
    descripcion:    '',  
    activo:         false,
}

// Creación de interfaces

export interface PaisProps{    
    idPais:         number;
    descripcion:    string;
    activo:         boolean;
}
